export default "__VITE_ASSET__JkIA63$q__"